var PROGRESS_BAR_STATUS = {
  loading: 'loading',
  success: 'success',
  error: 'error'
};

export { PROGRESS_BAR_STATUS as default };
